import { useAuth } from 'hooks/auth'
import React from 'react'
import { Link } from 'react-router-dom'
import { HOME } from 'routes'

const ResourceDeleted: React.FC<{ inProcess?: boolean }> = ({ inProcess }) => {
  const { user } = useAuth()
  return (
    <div className="bg-surface flex flex-1 items-center justify-center overflow-hidden box-border h-screen w-full px-20">
      <div className="flex flex-col w-full justify-center items-center">
        <div className={inProcess ? 'text-2xl mt-[250px]' : 'text-[2rem] mt-0'}>
          Sorry, the resource you were looking for was not found.
        </div>
        {!inProcess && user && (
          <Link className="mt-5 text-[1.1rem]" to={HOME}>
            Return To Home
          </Link>
        )}
      </div>
    </div>
  )
}

export default ResourceDeleted
